import axios from "axios"

export default axios.create({
    baseURL: "https://api.online-comix.ru/api/",
    responseType: "json"
})